import { Guardian } from '@xaamin/guardian';

Guardian.define('facturacion.masiva.subir.archivo', (user) => {
  return user.can('facturacion.masiva.subir.archivo');
});

Guardian.define('facturacion.masiva.listar.archivos', (user) => {
  return user.can('facturacion.masiva.listar.archivos');
});

Guardian.define('facturacion.masiva.listar.tickets', (user) => {
  return user.can('facturacion.masiva.listar.tickets');
});

Guardian.define('facturacion.masiva.descarga.masiva', (user) => {
  return user.can('facturacion.masiva.descarga.masiva');
});

Guardian.define('facturacion.masiva.descargar.excel.procesado', (user) => {
  return user.can('facturacion.masiva.descargar.excel.procesado');
});

Guardian.define('facturacion.masiva.descargar.archivo.original', (user) => {
  return user.can('facturacion.masiva.descargar.archivo.original');
});